/**
 * goalParams.js — Presets séries/reps/repos par objectif, partagés entre AssistedProgramBuilder
 * (programme suggéré) et CustomBeginnerFlow (parcours "Choisir moi-même").
 */
export const GOAL_PARAMS = {
  'Prise de muscle': { sets: 4, reps: '8-12', rest: 90 },
  'Perte de poids': { sets: 3, reps: '15-20', rest: 45 },
  'Augmentation de la force': { sets: 5, reps: '4-6', rest: 150 },
  'Endurance musculaire': { sets: 3, reps: '15-20', rest: 45 },
  'Remise en forme générale': { sets: 3, reps: '10-15', rest: 60 },
  'Préparation sportive / mobilité': { sets: 3, reps: '10-15', rest: 60 },
};
